import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'actionType'
})
export class ActionTypePipe implements PipeTransform {

    transform(value: string, ...args: unknown[]): string {
        if (value === 'send_mail_from_attribute') {
            return 'Mail aus Attribut versenden';
        } else {
            return '';
        }
    }

}
